import { defineStore } from 'pinia'
import { ref } from 'vue'
import ConfigService, { type SegmentoUiConfig } from '@/services/admin/ConfigService'

export const useConfigStore = defineStore('config', () => {
  const uiConfig = ref<SegmentoUiConfig | null>(null)
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const fetchUiConfig = async () => {
    isLoading.value = true
    error.value = null
    try {
      uiConfig.value = await ConfigService.getUiConfig()
    } catch (err) {
      console.warn('Failed to load UI config:', err)
      error.value = 'Erro ao carregar configuração'
    } finally {
      isLoading.value = false
    }
  }

  const usaCampo = (campo: string): boolean => {
    if (!uiConfig.value) return false
    return (uiConfig.value as unknown as Record<string, boolean>)[campo] === true
  }

  return { uiConfig, isLoading, error, fetchUiConfig, usaCampo }
})
